var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1647",
    transform: "translate(-134 -2629)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 15",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(134 2629)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 147",
    d: "M165.015 2658v-6.621c0-3.237-.7-5.73-4.481-5.73a3.928 3.928 0 00-3.538 1.945h-.053v-1.639h-3.583v12.044h3.736v-5.964c0-1.57.3-3.089 2.242-3.089 1.916 0 1.945 1.792 1.945 3.189v5.864z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 148",
    d: "M147.283 2645.956h3.74V2658h-3.74z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 149",
    d: "M149.146 2639.96a2.176 2.176 0 102.167 2.166 2.167 2.167 0 00-2.167-2.166z",
    fill: "#fff"
  }))));
}
export default SvgLinkedininline;